module.exports = __webpack_public_path__ + "static/media/osi.bd3e421c.svg";